// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BoardConfTs from "../config/BoardConf.ts";

var steve = BoardConfTs.steve;

var shaun = BoardConfTs.shaun;

var claire = BoardConfTs.claire;

var roger = BoardConfTs.roger;

var susan = BoardConfTs.susan;

var edward = BoardConfTs.edward;

var ruth = BoardConfTs.ruth;

var cliff = BoardConfTs.cliff;

var philip = BoardConfTs.philip;

var adrian = BoardConfTs.adrian;

export {
  steve ,
  shaun ,
  claire ,
  roger ,
  susan ,
  edward ,
  ruth ,
  cliff ,
  philip ,
  adrian ,
}
/* steve Not a pure module */
